import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TGlobalAndProductSettings } from '~types/feat/setting';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateProductSettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingProductSettingCreateProductAttempt', handleCreateProductSettings, api);
}

function* handleCreateProductSettings(api: SettingGateway, data: PayloadAction<TGlobalAndProductSettings>) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;
    const settings = state.setting.settings.data;

    const response = yield* call([api, api.updateSettings], { authToken, ...data.payload });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingProductSettingCreateProductFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingProductSettingCreateProductSuccess(response.data));
        yield put(combinedActions.settingSetProductSettingCreateProductModalIsOpen(false));
        yield put(combinedActions.goldGetAllProductsAttempt());
        yield put(combinedActions.settingGetSettingsAttempt());

        toast.success(SuccessMessages.SettingUpdateSettingsSuccess);
    }
}
